import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createTransfer, getRailwayData, getRailwayDataByBureau } from '../services/api';

function Publish() {
  const [form, setForm] = useState({
    type: '对调',
    currentBureau: '',
    targetBureau: '',
    currentUnit: '',
    targetUnit: '',
    currentWorkshop: '',
    targetWorkshop: '',
    contact: '',
    remark: ''
  });
  const [bureauNames, setBureauNames] = useState([]);
  const [currentUnitOptions, setCurrentUnitOptions] = useState([]);
  const [targetUnitOptions, setTargetUnitOptions] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadRailwayData();
  }, []);

  useEffect(() => {
    if (form.currentBureau) {
      loadBureauUnits(form.currentBureau, 'current');
    } else {
      setCurrentUnitOptions([]);
    }
  }, [form.currentBureau]);

  useEffect(() => {
    if (form.targetBureau) {
      loadBureauUnits(form.targetBureau, 'target');
    } else {
      setTargetUnitOptions([]);
    }
  }, [form.targetBureau]);

  const loadRailwayData = async () => {
    try {
      const res = await getRailwayData();
      setBureauNames(res.data.bureauNames);
    } catch (err) {
      console.error('加载数据失败', err);
    }
  };

  const loadBureauUnits = async (bureau, type) => {
    try {
      const res = await getRailwayDataByBureau(bureau);
      if (type === 'current') {
        setCurrentUnitOptions(res.data.allUnits);
      } else {
        setTargetUnitOptions(res.data.allUnits);
      }
    } catch (err) {
      console.error('加载站段数据失败', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await createTransfer(form);
      navigate('/myposts');
    } catch (err) {
      setError(err.response?.data?.error || '发布失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white rounded-lg shadow p-8">
        <h2 className="text-2xl font-bold mb-6">发布对调信息</h2>
        {error && <div className="bg-red-100 text-red-700 px-4 py-2 rounded mb-4">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">对调类型</label>
            <select
              required
              className="w-full border rounded px-3 py-2"
              value={form.type}
              onChange={(e) => setForm({ ...form, type: e.target.value })}
            >
              <option value="对调">对调</option>
              <option value="单调">单调</option>
            </select>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">当前铁路局</label>
              <select
                required
                className="w-full border rounded px-3 py-2"
                value={form.currentBureau}
                onChange={(e) => setForm({ ...form, currentBureau: e.target.value, currentUnit: '' })}
              >
                <option value="">请选择</option>
                {bureauNames.map(b => <option key={b} value={b}>{b}局</option>)}
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">目标铁路局</label>
              <select
                required
                className="w-full border rounded px-3 py-2"
                value={form.targetBureau}
                onChange={(e) => setForm({ ...form, targetBureau: e.target.value, targetUnit: '' })}
              >
                <option value="">请选择</option>
                {bureauNames.map(b => <option key={b} value={b}>{b}局</option>)}
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">当前站段</label>
              <select
                required
                className="w-full border rounded px-3 py-2"
                value={form.currentUnit}
                onChange={(e) => setForm({ ...form, currentUnit: e.target.value })}
                disabled={!form.currentBureau}
              >
                <option value="">请选择</option>
                {currentUnitOptions.map(u => <option key={u} value={u}>{u}</option>)}
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">目标站段</label>
              <select
                required
                className="w-full border rounded px-3 py-2"
                value={form.targetUnit}
                onChange={(e) => setForm({ ...form, targetUnit: e.target.value })}
                disabled={!form.targetBureau}
              >
                <option value="">请选择</option>
                {targetUnitOptions.map(u => <option key={u} value={u}>{u}</option>)}
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">当前车间 (可选)</label>
              <input
                type="text"
                className="w-full border rounded px-3 py-2"
                placeholder="例如: 检修一车间"
                value={form.currentWorkshop}
                onChange={(e) => setForm({ ...form, currentWorkshop: e.target.value })}
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">目标车间 (可选)</label>
              <input
                type="text"
                className="w-full border rounded px-3 py-2"
                placeholder="例如: 检修二车间"
                value={form.targetWorkshop}
                onChange={(e) => setForm({ ...form, targetWorkshop: e.target.value })}
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 mb-2">联系方式</label>
            <input
              type="text"
              required
              className="w-full border rounded px-3 py-2"
              placeholder="手机号或其他联系方式"
              value={form.contact}
              onChange={(e) => setForm({ ...form, contact: e.target.value })}
            />
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 mb-2">补充备注</label>
            <textarea
              className="w-full border rounded px-3 py-2"
              rows="4"
              placeholder="其他补充信息..."
              value={form.remark}
              onChange={(e) => setForm({ ...form, remark: e.target.value })}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? '发布中...' : '发布信息'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Publish;
